import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DATE_FORMAT, TIME_FORMAT } from '../../../constants';
import { useActiveListContext } from '../../../context';
import { DEFAULT_LIST } from '../../../constants';

export const TimeDisplay = ({ task, ...props }) => {
  const [realTime, setRealTime] = useState(moment());
  const [isExpired, setIsExpired] = useState(false);
  const [dateDisplay, setDateDisplay] = useState();

  const { listName } = useActiveListContext();
  const toCompare = moment(task.date);
  const display = moment(task.date, DATE_FORMAT).format('MMM D YYYY');

  useEffect(() => {
    const intervalID = setTimeout(() => {
      const current = moment();
      setRealTime(current);
      let temp = display,
        tempExpire = false;
      const cur = moment(current.format(DATE_FORMAT));

      if (cur.isSame(toCompare)) {
        if (listName != DEFAULT_LIST) temp = 'Today';
        else temp = '';
      } else if (cur.isBefore(toCompare)) {
        if (toCompare.diff(cur, 'days') == 1) temp = 'Tomorrow';
      } else {
        tempExpire = true;
        if (cur.diff(toCompare, 'days') == 1) temp = 'Yesterday';
      }

      if (task.time != '') {
        if (
          current.isSameOrBefore(
            moment(`${task.date} ${task.time}`, `${DATE_FORMAT} ${TIME_FORMAT}`)
          )
        )
          tempExpire = false;
        else tempExpire = true;

        temp += (temp == '' ? '' : ', ') + task.time;
      }

      setIsExpired(tempExpire);
      setDateDisplay(temp);
    }, 500);
    return () => clearInterval(intervalID);
  }, [realTime]);

  return (
    <div {...props}>
      <span
        style={{
          color: isExpired ? 'red' : 'rgba(0,0,0,0.55)',
          wordBreak: 'break-all',
        }}
      >
        {dateDisplay}
      </span>
    </div>
  );
};
